import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from './Modal';
import i18n from '../utils/i18n';
import { resetModal } from '../actions/modalsActions';
import { validateEmail } from '../utils/other';

import './styles/BookingModal.scss';

class InviteFriendsToBookingComponent extends React.Component {
  constructor(props) {
    super(props);

    const friendsEmailsInitial = {};
    for (let i = 1; i <= props.inviteFriendsCount; i += 1) {
      friendsEmailsInitial[i] = {
        value: '',
        error: ''
      };
    }

    this.state = {
      friendsEmails: friendsEmailsInitial
    };
  }

  handleEmailChange(event) {
    const { name, value } = event.target;
    this.updateFriendEmail(name, value);
  }

  updateFriendEmail(name, value, error = '') {
    const updatedFriendsEmails = this.state.friendsEmails;
    updatedFriendsEmails[name] = {
      value,
      error
    };
    this.setState({ friendsEmails: updatedFriendsEmails });
  }

  validateEmailAdresses(emails, emailsRequired) {
    const alreadyValidatedEmails = [];
    let emailsCorrect = Object.keys(emails).length > 0;

    Object.keys(emails).forEach(key => {
      const email = emails[key];
      const { value } = email;
      if (validateEmail(value)) {
        if (alreadyValidatedEmails.indexOf(value) !== -1) {
          this.updateFriendEmail(
            key,
            value,
            i18n.t('modals.booking.inviteFriends.PLEASE_DO_NOT_REPEAT_EMAILS')
          );
          emailsCorrect = false;
        } else {
          alreadyValidatedEmails.push(value);
        }
      } else if (emailsRequired || value) {
        this.updateFriendEmail(
          key,
          value,
          i18n.t('modals.booking.inviteFriends.EMAIL_INCORRECT')
        );
        emailsCorrect = false;
      }
    });

    return emailsCorrect;
  }

  startAction() {
    const emails = this.state.friendsEmails;
    if (this.validateEmailAdresses(emails, this.props.emailsRequired)) {
      this.props.actionFunction(
        Object.values(emails)
          .map(email => email.value)
          .filter(value => value)
      );
    }
  }

  render() {
    const { inviteFriendsCount } = this.props;
    const { friendsEmails } = this.state;
    const inviteFriendsEmailsInputs = [];
    for (let i = 1; i <= inviteFriendsCount; i += 1) {
      inviteFriendsEmailsInputs.push(
        <div className="form-group" key={ i }>
          <input
            name={ i }
            onChange={ event => this.handleEmailChange(event) }
            className="private-data form-control"
            placeholder={ i18n.t(
              'modals.booking.inviteFriends.EMAIL_PLACEHOLDER'
            ) }
          />
          <div className="email-input-error">
            {friendsEmails[i] ? friendsEmails[i].error : ''}
          </div>
        </div>
      );
    }

    return (
      <Modal
        isOpen={ true }
        onRequestClose={ this.props.resetModal }
        closeButtonText={ i18n.t('modals.booking.inviteFriends.CLOSE') }
        actionButtonText={ i18n.t(
          'modals.booking.inviteFriends.INVITE_FRIENDS_AND_MAKE_BOOKING'
        ) }
        actionFunction={ () => this.startAction() }
      >
        <div className="modal-container booking-modal-container">
          <h1 className="modal-header confirm-booking-header">
            {i18n.t('modals.booking.inviteFriends.CONFIRM_BOOKING')}
          </h1>

          <div className="invite-friends-wrapper">
            <div
              className="invite-friends-label"
              style={ { marginBottom: '20px' } }
            >
              {inviteFriendsCount > 1
                ? i18n.t('modals.booking.inviteFriends.PUT_EMAILS_DOUBLES')
                : i18n.t(
                  'modals.booking.inviteFriends.PUT_EMAILS_SINGLES'
                )}
              {' '}
            </div>
            <div className="invite-friends-inputs">
              {inviteFriendsEmailsInputs}
            </div>
            {this.props.bookingFailure && (
              <div className="booking-failed">
                {this.props.bookingError}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

InviteFriendsToBookingComponent.propTypes = {
  resetModal: PropTypes.func.isRequired,
  actionFunction: PropTypes.func,
  inviteFriendsCount: PropTypes.number,
  bookingError: PropTypes.string,
  bookingFailure: PropTypes.bool,
  emailsRequired: PropTypes.bool
};

InviteFriendsToBookingComponent.defaultProps = {
  actionFunction: () => {},
  inviteFriendsCount: 2,
  bookingError: '',
  bookingFailure: false,
  emailsRequired: false
};

const mapDispatchToProps = dispatch => ({
  resetModal: () => dispatch(resetModal())
});

export default connect(
  null,
  mapDispatchToProps
)(InviteFriendsToBookingComponent);



// WEBPACK FOOTER //
// ./src/modals/InviteFriendsToBookingComponent.js